export const RoutePaths = {
    Admin: {
        Applications: 'admin/applications',
        Workspaces: 'admin/workspaces',
        WorkspaceReports: 'admin/workspaces/',
        ReportAudit: 'admin/audits/reports',
        SystemAudit: 'admin/audits/systems',
        ClientAdmitReportAudit: 'admin/audits/clientadminreport',
        UserReportsAudit: 'admin/audits/userreports',
    },
    User: {
        Applications: 'applications',
        Reports: 'reports/',
        ReportsFullScreen: 'reports/fullscreen',
        UserDashboard: 'applications/',
        SharedReport: 'sharedreport/'
    },
    Home: '',
    DefaultRedirect: '*',
  } as const;
